<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <div class="home_layout">
                    <div>
                        <div class="home_lists">
                            <router-link to="#" @click="goTitleHealthDetail('stress')">
                                <div class="title">
                                    <img src="@/assets/user/home/home_list_ico1.png" alt="">
                                    <div>
                                        <p>Stress</p>
                                        <p>스트레스</p>
                                    </div>
                                </div>
                                <p class="point" v-if="health.stress === null || health.stress === undefined">
                                    <span>-</span>
                                </p>
                                <p class="point" v-else>
                                    <span>{{ health.stress }}</span>점
                                </p>
                            </router-link>
                            <router-link to="#" @click="goTitleHealthDetail('fatigue')">
                                <div class="title">
                                    <img src="@/assets/user/home/home_list_ico2.png" alt="">
                                    <div>
                                        <p>Fatigability</p>
                                        <p>피로도</p>
                                    </div>
                                </div>
                                <p class="point" v-if="health.fatigue === null || health.fatigue === undefined">
                                    <span>-</span>
                                </p>
                                <p class="point" v-else>
                                    <span>{{ health.fatigue }}</span>점
                                </p>
                            </router-link>
                        </div>
                        <div class="home_btn_lists">
                            <router-link to="#" @click="goDetailHealth('diastole')">
                                <p v-if="health.diastole">
                                    <span class="preEB">{{ health.diastole }}</span>mmHg
                                </p>
                                <p v-else>
                                    <span class="preEB">-</span>
                                </p>
                                <p><img src="@/assets/user/home/home_btn_list_ico1.png" alt="">혈압(수축기)</p>
                            </router-link>
                            <router-link to="#" @click="goDetailHealth('systole')">
                                <p v-if="health.systole"><span class="preEB">{{ health.systole }}</span>mmHg</p>
                                <p v-else>
                                    <span class="preEB">-</span>
                                </p>
                                <p><img src="@/assets/user/home/home_btn_list_ico1.png" alt="">혈압(이완기)</p>
                            </router-link>
                            <router-link to="#" @click="goDetailHealth('bitHeart')">
                                <p v-if="health.bitHeart"><span class="preEB">{{ health.bitHeart }}</span>bpm</p>
                                <p v-else>
                                    <span class="preEB">-</span>
                                </p>
                                <p><img src="@/assets/user/home/home_btn_list_ico2.png" alt="">심박수</p>
                            </router-link>
                            <router-link to="#" @click="goDetailHealth('temperature')">
                                <p v-if="health.temperature"><span class="preEB">{{ health.temperature }}</span>˚C</p>
                                <p v-else>
                                    <span class="preEB">-</span>
                                </p>
                                <p><img src="@/assets/user/home/home_btn_list_ico3.png" alt="">체온</p>
                            </router-link>
                            <router-link to="#" @click="goDetailHealth('spO2')">
                                <p v-if="health.spO2"><span class="preEB">{{ health.spO2 }}</span>%</p>
                                <p v-else>
                                    <span class="preEB">-</span>
                                </p>
                                <p><img src="@/assets/user/home/home_btn_list_ico4.png" alt="">산소포화도</p>
                            </router-link>
                            <router-link to="#" @click="goDetailHealth('weight')">
                                <p v-if="health.weight"><span class="preEB">{{ health.weight }}</span>kg</p>
                                <p v-else>
                                    <span class="preEB">-</span>
                                </p>
                                <p><img src="@/assets/user/home/home_btn_list_ico5.png" alt="">체중</p>
                            </router-link>
                            <router-link to="#" @click="goDetailHealth('muscleMass')">
                                <p v-if="health.muscleMass">
                                    <span class="preEB">{{ floatFormat(health.muscleMass) }}</span>kg
                                </p>
                                <p v-else>
                                    <span class="preEB">-</span>
                                </p>
                                <p><img src="@/assets/user/home/home_btn_list_ico6.png" alt="">골격근량</p>
                            </router-link>
                            <router-link to="#" @click="goDetailHealth('fatRatio')">
                                <p v-if="health.fatRatio">
                                    <span class="preEB">{{ floatFormat(health.fatRatio) || "-" }}</span>%
                                </p>
                                <p v-else>
                                    <span class="preEB">-</span>
                                </p>

                                <p><img src="@/assets/user/home/home_btn_list_ico7.png" alt="">체지방률</p>
                            </router-link>
                        </div>
                    </div>
                    <div>
                        <router-link to="#" class="home_form_btn" @click="checkCntSurvey">
                            <span>
                                <img src="@/assets/user/home/form_ico.png" alt=""> 설문조사
                            </span>
                            <span>
                                <b class="preEB">{{ state.cntSurvey }}</b>건
                                <img src="@/assets/user/home/form_go_ico.png" alt="">
                            </span>
                        </router-link>
                    </div>
                    <div>
                        <p class="home_section_tit">커뮤니티</p>
                        <ul class="home_board">
                            <template v-for="item in community.content">
                                <li v-if="item.isImportant === 1">
                                    <router-link to="#" @click="goCommunity(item.idx)">
                                        <span class="title">
                                            <span class="mainNotice">공지</span>
                                            <span v-html="item.title"></span>
                                        </span>
                                    </router-link>
                                </li>
                            </template>
                            <template v-for="item in community.content">
                                <li v-if="item.isImportant === 0">
                                    <router-link to="#" @click="goCommunity(item.idx)">
                                        <span class="title">
                                            <p v-html="item.title"></p>
                                        </span>
                                        <span class="date">{{ formatDate(item.createDate) }}</span>
                                    </router-link>
                                </li>
                            </template>
                        </ul>
                    </div>
                    <div>
                        <p class="home_section_tit">스트레스 케어</p>
                        <ul class="home_gallery">
                            <li v-for="item in stressCare.content">
                                <router-link to="#" @click="goStressCare(item.idx)">
                                    <div class="thumb">
                                        <img :src="item.thumbnail" alt="">
                                    </div>
                                    <div class="title">{{ item.title }}</div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p class="home_section_tit">경찰청 Youtube</p>
                        <div class="home_youtube" v-for="item in youtube.content">
                            <div class="video">
                                <iframe width="100%" height="100%" :src="item.youtubeLink" frameborder="0"
                                    allowfullscreen></iframe>
                            </div>
                            <div class="video_bar">
                                <p>{{ item.title }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :no="modal.cancel" :content="modal.content" @close="modalClose">
    </ModalComponent>
</template>
<script lang="ts" config>
import {
    userStore,
    globalStore,
    reactive,
    onMounted,
    apiService,
    res,
    HeaderLayout,
    GnbLayout,
    router,
    floatFormat,
    ModalComponent,
    formatDate,
    sortListDate,
} from "@/BaseComponent";

interface youtube {
    idx: number;
    title: string,
    youtubeLink: string,
}
interface community {
    idx: number,
    title: string,
    createDate: string,
    isImportant: number,
}
interface stressCare {
    idx: number,
    thumbnail: string,
    title: string,
}
export default {
    props: {},
    components: {
        HeaderLayout,
        GnbLayout,
        ModalComponent,
    },
    setup() {
        const global = globalStore();
        const user = userStore();
        const state = reactive({
            cntSurvey: 0 as number,
            isNavOpen: false as boolean,
            isModalOpen: false as boolean
        });

        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number
        });

        const health = reactive({
            stress: 0 as number,
            fatigue: 0 as number,
            systole: 0 as number,
            diastole: 0 as number,
            bitHeart: 0 as number,
            temperature: 0 as number,
            spO2: 0 as number,
            weight: 0 as number,
            muscleMass: 0 as number,
            fatRatio: 0 as number
        });

        const youtube = reactive({
            content: [] as Array<youtube>,
            cnt: 2 as number,
        });

        const community = reactive({
            content: [] as Array<community>,
            cnt: 5 as number,
        });

        const stressCare = reactive({
            content: [] as Array<stressCare>,
            cnt: 2 as number,
        });
        const acceptData = [
            { tag: "bitHeart", key: "heartRate", chart: "candle" },
            { tag: "spO2", key: "oxygenSaturation", chart: "candle" },
            { tag: "temperature", key: "temperature", chart: "line" },
            { tag: "diastole", key: "electrocardiogram", chart: "line" },
            { tag: "systole", key: "electrocardiogram", chart: "line" },
            { tag: "stress", key: "electrocardiogram", chart: "line" },
            { tag: "fatigue", key: "electrocardiogram", chart: "line" },
            { tag: "weight", key: "vegetableIngredients", chart: "line" },
            { tag: "muscleMass", key: "vegetableIngredients", chart: "line" },
            { tag: "fatRatio", key: "vegetableIngredients", chart: "line" },
        ];

        onMounted(async () => {
            getUserInfo();
            getYoutubeLink();
            getCommunity();
            getStressCare();
            global.setSelectMenu("home");
        });

        const getUserInfo = async () => {
            const res: res = await apiService.member.getInfo();
            if (res.returnCode === 0) {
                user.setInfo({ name: res.data?.name, idx: res.data?.idx });
                state.cntSurvey = res.data.cntSurvey;
                health.bitHeart = res.data.bitHeart;
                health.spO2 = res.data.spO2;
                health.temperature = res.data.temperature;
                health.diastole = res.data.disatole;
                health.systole = res.data.systole;
                health.stress = res.data.stress;
                health.fatigue = res.data.fatigue;
                health.weight = res.data.weight;
                health.muscleMass = res.data.muscleMass;
                health.fatRatio = res.data.fatRatio;
            }
        };
        const getYoutubeLink = async () => {
            const res = await apiService.youtube.getList(1, youtube.cnt, "");
            if (res.returnCode === 0) {
                youtube.content = res.data.data;
            }
        };
        const getCommunity = async () => {
            let res = await apiService.community.getList(1, community.cnt, "");
            if (res.returnCode === 0) {
                community.content = res.data.data;
                sortListDate(community.content);
            }
        };
        const getStressCare = async () => {
            let res = await apiService.stressCare.getList(1, 0, stressCare.cnt, "");
            if (res.returnCode === 0) {
                stressCare.content = res.data.data;
            }
        };

        const goDetailHealth = (tag: string) => {
            let tempArr = acceptData.filter((r) => r.tag === tag).map((r) => [r.key, r.chart, r.tag]);
            if (tempArr && tempArr.length > 0) {
                router.push({
                    path: "/health/detail/" + tempArr[0][0],
                    query: { data: tempArr[0] },
                });
            } else {
                modal.content = "올바르지 않은 선택지입니다.";
                state.isModalOpen = true;
            }
        };

        const goTitleHealthDetail = (tag: string) => {
            router.push({
                path: "/health/detail/stress",
                query: {
                    data: ["electrocardiogram", "line", tag]
                }
            });
        };

        const checkCntSurvey = (e: any) => {
            e.preventDefault();
            if (state.cntSurvey === 0 || state.cntSurvey === undefined || state.cntSurvey === null) {
                modal.content = "참여가능한 설문이 없습니다.";
                state.isModalOpen = true;
            } else {
                router.push("/survey/list");
            }
        };

        const modalClose = () => {
            state.isModalOpen = false;
        };

        const goStressCare = (idx: number) => {
            router.push({ path: `/stressCare/detail/${idx}` });
        };

        const goCommunity = (idx: number) => {
            router.push({ path: `/community/detail/${idx}` });
        };
        return {
            state,
            health,
            modal,
            youtube,
            community,
            stressCare,
            goDetailHealth,
            goTitleHealthDetail,
            floatFormat,
            acceptData,
            checkCntSurvey,
            modalClose,
            formatDate,
            goStressCare,
            goCommunity,
        };
    },
};
</script>
<style scoped>
.mainNotice {
    color: #fff;
    background-color: var(--blue);
    display: inline-block;
    padding: 2px 4px;
    font-weight: normal;
    font-size: 13px;
    margin-right: 5px;
}

.home_youtube .video_bar p {
    text-align: unset;
}
</style>